<template>
  <button class="button button-secondary">{{ text }}</button>
</template>
<script>
export default {
  props: [
    "text"
  ],
}
</script>